import type { EditRequest, EditEntityKind } from '@/lib/ai-composer/types';

export function buildChartEditRequest(
  entityId: string,
  entityKind: EditEntityKind,
  range: { from: number; to: number },
): EditRequest {
  return {
    action: 'generate-chart',
    entityKind,
    entityId,
    target: { kind: 'tiptap-range', from: range.from, to: range.to },
  };
}
